import * as LabelPrimitive from '@radix-ui/react-label'
import * as React from 'react'

// Define label styles
const labelStyles: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '14px',
    lineHeight: '1',
    fontWeight: '500',
    userSelect: 'none'
}

const disabledLabelStyles: React.CSSProperties = {
    pointerEvents: 'none',
    opacity: '0.5',
    cursor: 'not-allowed'
}

function Label({ className, style, disabled, ...props }: React.ComponentProps<typeof LabelPrimitive.Root> & { disabled?: boolean }) {
    return (
        <LabelPrimitive.Root
            data-slot='label'
            className={className}
            style={{
                ...labelStyles,
                ...(disabled ? disabledLabelStyles : {}),
                ...style
            }}
            {...props}
        />
    )
}

export { Label }
